import React, { useEffect } from "react";
import "./card.result.css";
import { upperCase } from "lodash";
import { config } from "../../../../services/config";

const pic = "https://www.colorhexa.com/a4dded.png";
// const logo =
//   "https://darearqam.com/wp-content/uploads/2020/03/daraarqam-logo.jpg";

function ResulftCardForPrint({
  studentResultList,
  studentFinalResult,
  studentDetails,
  campusDetail,
  student_result_overall,
  isInclude,
  currentExam,
  icon,
  unitName,
  weekList,
  signatureIcon,
  studentRemarkCheck,
  examRemark,
  controllerSignatureCheck,
  studentResultGradeWise,
  isPracticalMode,
}) {
  const getMonthName = (date) => {
    const monthNames = [
      "January", // index 0
      "February", // index 1
      "March", // index 2
      "April", // index 3
      "May", // index 4
      "June", // index 5
      "July", // index 6
      "August", // index 7
      "September", // index 8
      "October", // index 9
      "November", // index 10
      "December", // index 11
    ];
    const d = new Date(date);

    return upperCase(`${monthNames[d.getMonth()]}, ${d.getFullYear()}`);
  };

  // Function to get the name by week_id
  const getWeekNameById = (week_id) => {
    const week = weekList.find((w) => w.id == week_id);
    return week ? week.name : "Unknown Week"; // Return name or a default value
  };
  const position = isInclude
    ? studentFinalResult?.position
    : student_result_overall?.position;
  return (
    <table>
      <tbody>
        <tr>
          <td>
            <table
              className="result__card__table"
              border="2"
              cellpadding="0"
              cellspacing="0"
              width="100%"
            >
              <tbody>
                <tr>
                  <td style={{ width: "118px", textAlign: "center" }}>
                    <img className="p-1" id="Image1" src={icon} width={100} />
                  </td>
                  <td style={{ width: "457", textAlignLast: "center" }}>
                    <span
                      style={{
                        fontSize: "1.85rem",
                        color: `${config.txtColor}`,
                        fontWeight: "bold",
                      }}
                      id="LblOIDName"
                    >
                      {unitName}
                    </span>
                    <br />
                    <span
                      style={{
                        fontSize: "1.65rem",
                        color: `${config.txtColor}`,
                        fontWeight: "bold",
                      }}
                      id="LblTermName"
                    >
                      RESULT CARD
                    </span>
                    <br />
                    <span
                      style={{
                        fontSize: "1.5rem",
                        color: `${config.txtColor}`,
                        fontWeight: "bold",
                      }}
                      id="LblTermName"
                    >
                      {campusDetail?.exam?.exam_type?.name}
                      {campusDetail?.exam?.week_id != null
                        ? campusDetail?.exam?.month != null
                          ? " " +
                            "( " +
                            getWeekNameById(campusDetail?.exam?.week_id) +
                            " OF " +
                            getMonthName(campusDetail?.exam?.month) +
                            " )"
                          : " " +
                            "( " +
                            getWeekNameById(campusDetail?.exam?.week_id) + // Use the week name only
                            " )"
                        : campusDetail?.exam?.month != null
                        ? " " +
                          "( " +
                          getMonthName(campusDetail?.exam?.month) +
                          " )"
                        : ""}
                    </span>
                  </td>
                  <td
                    style={{ width: "125px", textAlign: "center" }}
                    rowSpan={2}
                  >
                    <img
                      id="StudentImage"
                      src={
                        studentDetails?.picture != null
                          ? studentDetails?.picture
                          : "/media/users/blank.png"
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                      }}
                      alt="Student"
                      style={{ height: 135, width: 124, marginRight: 15 }}
                    />
                  </td>
                </tr>

                <>
                  <tr>
                    <td colSpan="2">
                      <table
                        border="0"
                        cellpadding="5"
                        cellspacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "145px",
                                textAlign: "right",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Admission ID :-
                            </td>
                            <td
                              style={{
                                fontSize: "1.5rem",

                                width: "330px",
                                textAlign: "start",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblAdmissionID"
                                className="BoldText"
                              >
                                {studentDetails?.admission_id}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "90px",
                                textAlign: "right",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Session :-
                            </td>
                            <td
                              align="Center"
                              style={{
                                fontSize: "1.5rem",

                                width: "135px",
                                textAlign: "left",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span id="LblSession" className="NormalText">
                                {campusDetail?.exam?.session?.year}{" "}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <table
                        border="1"
                        cellPadding="2"
                        cellSpacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "125px",
                                border: "1px solid black",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Name
                            </td>
                            <td
                              style={{
                                fontSize: "1.5rem",
                                width: "575px",
                                border: "1px solid black",
                                textAlign: "start",
                                paddingLeft: "10px",
                                color: `${config.txtColor}`,
                              }}
                              colSpan="3"
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblName"
                                className="NormalText"
                              >
                                {studentDetails?.name}{" "}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "125px",
                                border: "1px solid black",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Father's Name
                            </td>
                            <td
                              colSpan="3"
                              style={{
                                width: "575px",
                                border: "1px solid black",
                                textAlign: "start",
                                paddingLeft: "10px",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblFather"
                                className="NormalText"
                              >
                                {studentDetails?.father_name}{" "}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="BoldText"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "125px",
                                border: "1px solid black",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Class
                            </td>
                            <td
                              style={{
                                width: "240px",
                                border: "1px solid black",
                                textAlign: "start",
                                paddingLeft: "10px",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblClass"
                                className="NormalText"
                              >
                                {campusDetail?.student_class?.name ??
                                  studentResultList[0]?.student_class
                                    ?.name}{" "}
                              </span>
                            </td>
                            <td
                              className="LabelStyle"
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                width: "80px",
                                border: "1px solid black",
                                color: `${config.txtColor}`,
                              }}
                            >
                              Section
                            </td>
                            <td
                              align="Center"
                              style={{
                                width: "255px",
                                border: "1px solid black",
                                textAlign: "start",
                                paddingLeft: "10px",
                                color: `${config.txtColor}`,
                              }}
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblSection"
                                className="NormalText"
                              >
                                {campusDetail?.global_section?.name ??
                                  studentResultList[0]?.global_section?.name}
                              </span>
                            </td>
                          </tr>
                          {/* <tr>
                            <td
                              colspan="4"
                              style={{
                                border: "1px solid black",
                                textAlign: "start",
                              }}
                            >
                              <span
                                style={{ fontSize: "1.5rem" }}
                                id="LblCourse"
                                className="NormalText"
                              >
                                Detail of Marks Obtained
                              </span>
                            </td>
                          </tr> */}
                          <tr>
                            <td colspan="4">
                              <table
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td>
                                      <div>
                                        <table
                                          className="GridStyleResultCard"
                                          cellSpacing="0"
                                          rules="all"
                                          border="2"
                                          id="GridView1"
                                          style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                          }}
                                        >
                                          <tbody>
                                            <tr
                                              className="GridHeaderStyle"
                                              style={{
                                                border: "1px solid black",
                                              }}
                                            >
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                SUBJECTS
                                              </th>
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  width: "110px",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Total Marks
                                              </th>
                                              {!isPracticalMode && (
                                                <th
                                                  style={{
                                                    fontSize: "1.5rem",

                                                    border: "1px solid black",
                                                    color: `${config.txtColor}`,
                                                  }}
                                                  scope="col"
                                                >
                                                  Theory
                                                </th>
                                              )}
                                              {!isPracticalMode && (
                                                <th
                                                  style={{
                                                    fontSize: "1.5rem",

                                                    border: "1px solid black",
                                                    color: `${config.txtColor}`,
                                                  }}
                                                  scope="col"
                                                >
                                                  Presentation
                                                </th>
                                              )}
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Total Gain
                                              </th>
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                %
                                              </th>
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Grade
                                              </th>
                                              <th
                                                style={{
                                                  fontSize: "1.5rem",

                                                  border: "1px solid black",
                                                  color: `${config.txtColor}`,
                                                }}
                                                scope="col"
                                              >
                                                Remarks
                                              </th>
                                            </tr>
                                            {studentResultList &&
                                              studentResultList.map(
                                                (onePersonResult, index) => (
                                                  <tr className="GridRowStyle">
                                                    <td
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",

                                                        width: "300px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "start",
                                                        paddingLeft: "10px",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {
                                                        onePersonResult?.subject
                                                          ?.name
                                                      }{" "}
                                                    </td>
                                                    <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",

                                                        width: "90px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {
                                                        onePersonResult?.full_marks
                                                      }
                                                    </td>
                                                    {!isPracticalMode && (
                                                      <td
                                                        align="center"
                                                        // valign="middle"
                                                        style={{
                                                          fontSize: "1.5rem",

                                                          width: "90px",
                                                          border:
                                                            "1px solid black",
                                                          textAlign: "center",
                                                          color: `${config.txtColor}`,
                                                        }}
                                                      >
                                                        {onePersonResult.status ==
                                                        "Present"
                                                          ? onePersonResult.gain_marks
                                                          : onePersonResult.status}
                                                      </td>
                                                    )}

                                                    {!isPracticalMode && (
                                                      <td
                                                        style={{
                                                          fontSize: "1.5rem",

                                                          width: "90px",
                                                          border:
                                                            "1px solid black",
                                                          textAlign: "center",
                                                          color: `${config.txtColor}`,
                                                        }}
                                                      >
                                                        {onePersonResult?.practical_marks ==
                                                        0
                                                          ? "--"
                                                          : onePersonResult?.practical_marks}
                                                      </td>
                                                    )}
                                                    <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",
                                                        width: "130px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {Number(
                                                        onePersonResult.gain_marks,
                                                      ) +
                                                        Number(
                                                          onePersonResult?.practical_marks,
                                                        )}
                                                    </td>
                                                    <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",

                                                        width: "60px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {
                                                        onePersonResult?.percentage
                                                      }
                                                      %
                                                    </td>
                                                    <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",

                                                        width: "60px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.grade}
                                                    </td>
                                                    <td
                                                      align="center"
                                                      // valign="middle"
                                                      style={{
                                                        fontSize: "1.5rem",

                                                        width: "80px",
                                                        border:
                                                          "1px solid black",
                                                        textAlign: "center",
                                                        color: `${config.txtColor}`,
                                                      }}
                                                    >
                                                      {onePersonResult?.grade ==
                                                        "F" ||
                                                      onePersonResult?.grade ==
                                                        "F+"
                                                        ? "FAIL"
                                                        : "PASS"}
                                                    </td>
                                                  </tr>
                                                ),
                                              )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  {isInclude ? (
                    <>
                      {/* Annual Term */}
                      <tr>
                        <td colSpan="3" align="center">
                          <div
                            style={{
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                              borderLeft: "1px solid black",
                              // borderBottom: "1px solid black",
                            }}
                          >
                            <table
                              id="TblFail"
                              border="0"
                              cellPadding="0"
                              cellSpacing="0"
                              width="100%"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "BoldText muResult11"
                                        : "BoldText muResult1"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {currentExam?.exam}
                                  </td>

                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "muResult33"
                                        : "muResult2"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {currentExam?.full_marks}
                                  </td>

                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "muResult2"
                                        : "muResult3"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {currentExam?.gain_marks}
                                  </td>
                                  {currentExam?.fail_in.length > 0 &&
                                  currentExam?.full_marks > 0 ? (
                                    <>
                                      <td
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                          fontWeight: "bold",
                                          width: `${
                                            isPracticalMode ? "265px" : "478px"
                                          }`,
                                        }}
                                      >
                                        {currentExam?.fail_in.length > 0
                                          ? "Failed In"
                                          : ""}
                                        &nbsp;&nbsp;
                                        {currentExam?.fail_in.length > 0
                                          ? currentExam?.fail_in.map(
                                              (overvall, i) => (
                                                <span
                                                  style={{
                                                    fontSize: "1.5rem",
                                                    color: `${config.txtColor}`,
                                                    alignSelf: "flex-end",
                                                  }}
                                                  key={i + 1}
                                                  id="LblGazres"
                                                  className="BoldText"
                                                >
                                                  {overvall.substr(0, 3)}
                                                  {","}&nbsp;
                                                </span>
                                              ),
                                            )
                                          : null}
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      {!isPracticalMode && (
                                        <td
                                          style={{
                                            fontSize: "1.5rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          {currentExam?.practical_marks == 0
                                            ? "--"
                                            : currentExam?.practical_marks}
                                        </td>
                                      )}
                                      {!isPracticalMode && (
                                        <td
                                          className="muResult5"
                                          style={{
                                            fontSize: "1.5rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          {currentExam?.practical_marks +
                                            currentExam?.gain_marks}
                                        </td>
                                      )}
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult8"
                                            : "muResult6"
                                        }`}
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {currentExam?.percentage}
                                      </td>
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult6"
                                            : "muResult7"
                                        }`}
                                        id="forgrade"
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {currentExam?.grade}
                                      </td>
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult88"
                                            : "muResult8"
                                        }`}
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {/* Current Exam Pass/Fail Logic */}
                                        {currentExam?.grade == "F"
                                          ? "FAIL"
                                          : "PASS"}
                                      </td>
                                    </>
                                  )}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                      {/* First Term */}
                      <tr>
                        <td colSpan="3" align="center">
                          <div
                            style={{
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                              borderLeft: "1px solid black",
                              // borderBottom: "1px solid black",
                            }}
                          >
                            <table
                              id="TblFail"
                              border="0"
                              cellPadding="0"
                              cellSpacing="0"
                              width="100%"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "BoldText muResult11"
                                        : "BoldText muResult1"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {student_result_overall.exam}
                                  </td>

                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "muResult33"
                                        : "muResult2"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {student_result_overall?.full_marks}
                                  </td>

                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "muResult2"
                                        : "muResult3"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {student_result_overall?.gain_marks}
                                  </td>
                                  {student_result_overall?.fail_in.length > 0 &&
                                  student_result_overall?.full_marks > 0 ? (
                                    <>
                                      <td
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                          fontWeight: "bold",
                                          width: `${
                                            isPracticalMode ? "265px" : "478px"
                                          }`,
                                        }}
                                      >
                                        {student_result_overall?.fail_in
                                          .length > 0
                                          ? ""
                                          : ""}
                                        &nbsp;&nbsp;
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      {!isPracticalMode && (
                                        <td
                                          className="muResult4"
                                          style={{
                                            fontSize: "1.5rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          {student_result_overall.practical_marks ==
                                          0
                                            ? "--"
                                            : student_result_overall.practical_marks}
                                        </td>
                                      )}
                                      {!isPracticalMode && (
                                        <td
                                          className="muResult5"
                                          style={{
                                            fontSize: "1.5rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          {student_result_overall.practical_marks +
                                            Number(
                                              student_result_overall?.gain_marks,
                                            )}
                                        </td>
                                      )}
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult8"
                                            : "muResult6"
                                        }`}
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                          // paddingLeft:"25px",
                                        }}
                                      >
                                        {student_result_overall?.percentage}
                                      </td>
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult6"
                                            : "muResult7"
                                        }`}
                                        id="forgrade"
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {student_result_overall.grade}
                                      </td>
                                      <td
                                        className={`${
                                          isPracticalMode
                                            ? "muResult88"
                                            : "muResult8"
                                        }`}
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {/* First Term Pass/Fail Logic */}
                                      </td>
                                    </>
                                  )}
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                      {/* Overall Result */}
                      <tr>
                        <td colSpan="3" align="center">
                          <div
                            style={{
                              borderRight: "1px solid black",
                              borderTop: "1px solid black",
                              borderLeft: "1px solid black",
                              borderBottom: "1px solid black",
                            }}
                          >
                            <table
                              id="TblFail"
                              border="0"
                              cellPadding="0"
                              cellSpacing="0"
                              width="100%"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="BoldText muResult1"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    OVER ALL RESULT
                                  </td>
                                  <td
                                    className="muResult2"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {
                                      // Overall Total Marks
                                      studentFinalResult?.full_marks
                                    }
                                  </td>
                                  {!isPracticalMode && (
                                    <td
                                      className="muResult3"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {
                                        // Overall Gain Marks
                                        studentFinalResult?.gain_marks
                                      }
                                    </td>
                                  )}
                                  {!isPracticalMode && (
                                    <td
                                      className="muResult4"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {// Overall Practical Marks
                                      studentFinalResult?.practical_marks == 0
                                        ? "--"
                                        : studentFinalResult?.practical_marks}
                                    </td>
                                  )}
                                  <td
                                    className={`${
                                      isPracticalMode
                                        ? "muResult3"
                                        : "muResult5"
                                    }`}
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {// Overall Total Gain Marks
                                    studentFinalResult?.gain_marks +
                                      studentFinalResult?.practical_marks}
                                  </td>
                                  <td
                                    className="muResult6"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                      // paddingLeft:"25px",
                                    }}
                                  >
                                    {
                                      // Overall Percentage
                                      studentFinalResult?.percentage
                                    }
                                  </td>
                                  <td
                                    className="muResult7"
                                    id="forgrade"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {
                                      // Overall Grade Showing
                                      studentFinalResult?.grade
                                    }
                                  </td>

                                  {/* // Overall new pass/fail logic */}
                                  <td
                                    className="muResult8"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {studentFinalResult?.remarks}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="3" align="center">
                        <div
                          style={{
                            borderRight: "1px solid black",
                            borderTop: "1px solid black",
                            borderLeft: "1px solid black",
                            borderBottom: "1px solid black",
                          }}
                        >
                          <table
                            id="TblFail"
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                            width="100%"
                          >
                            <tbody>
                              <tr>
                                <td
                                  className="BoldText muResult1"
                                  style={{
                                    fontSize: "1.5rem",
                                    color: `${config.txtColor}`,
                                    fontWeight: "bold",
                                  }}
                                >
                                  OVER ALL RESULT
                                </td>

                                <td
                                  className="muResult2"
                                  style={{
                                    fontSize: "1.5rem",
                                    color: `${config.txtColor}`,
                                  }}
                                >
                                  {student_result_overall?.full_marks}
                                </td>

                                {!isPracticalMode && (
                                  <td
                                    className="muResult3"
                                    style={{
                                      fontSize: "1.5rem",
                                      color: `${config.txtColor}`,
                                    }}
                                  >
                                    {student_result_overall?.gain_marks}
                                  </td>
                                )}
                                {student_result_overall?.fail_in.length > 0 ? (
                                  <>
                                    {!isPracticalMode && (
                                      <td
                                        className="muResult4"
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {
                                          student_result_overall?.practical_marks
                                        }
                                      </td>
                                    )}
                                    <td
                                      className="muResult5"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {student_result_overall?.gain_marks +
                                        student_result_overall?.practical_marks}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                        fontWeight: "bold",
                                        width: `${
                                          isPracticalMode ? "215px" : ""
                                        }`,
                                      }}
                                    >
                                      {student_result_overall?.fail_in.length >
                                      0
                                        ? "Failed In"
                                        : ""}
                                      &nbsp;&nbsp;
                                      {student_result_overall?.fail_in.length >
                                      0
                                        ? student_result_overall?.fail_in.map(
                                            (overvall, i) => (
                                              <span
                                                style={{
                                                  fontSize: "1.5rem",
                                                  color: `${config.txtColor}`,
                                                  alignSelf: "flex-end",
                                                }}
                                                key={i + 1}
                                                id="LblGazres"
                                                className="BoldText"
                                              >
                                                {overvall.substr(0, 3)}
                                                {","}&nbsp;
                                              </span>
                                            ),
                                          )
                                        : null}
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    {!isPracticalMode && (
                                      <td
                                        className="muResult4"
                                        style={{
                                          fontSize: "1.5rem",
                                          color: `${config.txtColor}`,
                                        }}
                                      >
                                        {student_result_overall?.practical_marks ==
                                        0
                                          ? "--"
                                          : student_result_overall?.practical_marks}
                                      </td>
                                    )}
                                    <td
                                      className="muResult5"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {student_result_overall?.gain_marks +
                                        student_result_overall?.practical_marks}
                                    </td>
                                    <td
                                      className="muResult6"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                        // paddingLeft:"25px",
                                      }}
                                    >
                                      {student_result_overall?.percentage}
                                    </td>
                                    <td
                                      className="muResult7"
                                      id="forgrade"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {student_result_overall?.grade}
                                    </td>
                                    <td
                                      className="muResult8"
                                      style={{
                                        fontSize: "1.5rem",
                                        color: `${config.txtColor}`,
                                      }}
                                    >
                                      {student_result_overall?.remarks}
                                    </td>
                                  </>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td colSpan="3" style={{ textAlign: "left" }}>
                      {/* <br /> */}
                      <table
                        border="0"
                        cellPadding="0"
                        cellSpacing="0"
                        width="100%"
                      >
                        <tbody>
                          <tr>
                            <td colSpan="3" style={{ textAlign: "left" }}>
                              <div className="d-flex justify-content-between">
                                {studentResultList.length < 9 ? (
                                  <div style={{ marginTop: "20px" }}>
                                    <ul
                                      style={{
                                        fontSize: "1.25rem",
                                        color: `${config.txtColor}`,
                                        textAlign: "start",
                                        paddingLeft: "10px",
                                        listStyleType: "none",
                                        lineHeight: "1.75",
                                      }}
                                    >
                                      <li>
                                        <b>90% - Above</b> &nbsp;&nbsp;&nbsp; A+
                                        Grade - OutStanding.
                                      </li>
                                      <li>
                                        <b>80% - 89.99%</b> &nbsp;&nbsp;&nbsp;A
                                        Grade - Excellent.
                                      </li>
                                      <li>
                                        <b>70% - 79.99%</b> &nbsp;&nbsp;&nbsp; B
                                        Grade - Very Good.
                                      </li>
                                      <li>
                                        <b>60% - 69.99%</b> &nbsp;&nbsp;&nbsp;C
                                        Grade - Good.
                                      </li>
                                      <li>
                                        <b>50% - 59.99%</b> &nbsp;&nbsp;&nbsp;D
                                        Grade - Fair.
                                      </li>
                                      <li>
                                        <b>40% - 49.99%</b> &nbsp;&nbsp;&nbsp;E
                                        Grade - Weak.
                                      </li>
                                      <li>
                                        <b>&nbsp;&nbsp; 0% - 39.99%</b>{" "}
                                        &nbsp;&nbsp;&nbsp;F Grade - Fail.
                                      </li>
                                    </ul>
                                  </div>
                                ) : (
                                  <>
                                    <div style={{ marginTop: "20px" }}>
                                      <ul
                                        style={{
                                          fontSize: "1.25rem",
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                          paddingLeft: "10px",
                                          listStyleType: "none",
                                          lineHeight: "1.25",
                                        }}
                                      >
                                        <li>
                                          <b>90% - Above</b> &nbsp; A+ Grade -
                                          OutStanding.
                                        </li>
                                        <li>
                                          <b>80% - 89.99%</b>{" "}
                                          &nbsp;&nbsp;&nbsp;A Grade - Excellent.
                                        </li>
                                        <li>
                                          <b>70% - 79.99%</b> &nbsp;&nbsp;&nbsp;
                                          B Grade - Very Good.
                                        </li>
                                        <li>
                                          <b>60% - 69.99%</b>{" "}
                                          &nbsp;&nbsp;&nbsp;C Grade - Good.
                                        </li>
                                      </ul>
                                    </div>
                                    <div style={{ marginTop: "20px" }}>
                                      <ul
                                        style={{
                                          fontSize: "1.25rem",
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                          // paddingRight: "25rem",
                                          listStyleType: "none",
                                          lineHeight: "1.25",
                                        }}
                                      >
                                        <li>
                                          <b>50% - 59.99%</b> D Grade - Fair.
                                        </li>
                                        <li>
                                          <b>40% - 49.99%</b> E Grade - Weak.
                                        </li>
                                        <li>
                                          <b>&nbsp;&nbsp; 0% - 39.99%</b> F
                                          Grade - Fail.
                                        </li>
                                      </ul>
                                    </div>
                                  </>
                                )}

                                <div
                                  style={{
                                    marginTop: "20px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {position !== undefined &&
                                    position !== null &&
                                    position !== "" && (
                                      <div className="d-flex mr-6">
                                        <p
                                          style={{
                                            fontSize: "1.25rem",
                                            marginRight: "0.75rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          <b>Position:</b>
                                        </p>

                                        <p
                                          style={{
                                            fontSize: "1.25rem",
                                            color: `${config.txtColor}`,
                                          }}
                                        >
                                          {position}
                                        </p>
                                      </div>
                                    )}

                                  {studentResultGradeWise &&
                                  studentResultGradeWise.length > 0 ? (
                                    <table
                                      className="GridStyleResultCard"
                                      id="DataList1"
                                      // className="NormalText"
                                      cellSpacing="0"
                                      style={{
                                        borderCollapse: "collapse",
                                        marginRight: "2rem",
                                      }}
                                    >
                                      <thead>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            color: `${config.txtColor}`,
                                            fontSize: "1.3rem",
                                            width: "200px",
                                            textAlign: "center",
                                          }}
                                          scope="col"
                                        >
                                          SUBJECTS
                                        </th>
                                        <th
                                          style={{
                                            border: "1px solid black",
                                            color: `${config.txtColor}`,
                                            fontSize: "1.3rem",
                                            width: "70px",
                                            textAlign: "center",
                                          }}
                                          scope="col"
                                        >
                                          Grade
                                        </th>
                                      </thead>
                                      <tbody>
                                        {studentResultGradeWise &&
                                          studentResultGradeWise?.map(
                                            (item, index) => (
                                              <tr key={index}>
                                                <td
                                                  style={{
                                                    color: `${config.txtColor}`,
                                                    border: "1px solid black",
                                                    textAlign: "start",
                                                    padding: "0 0 0 10px",
                                                    fontSize: "1.2rem",
                                                    width: "200px",
                                                  }}
                                                >
                                                  {item?.subject?.name}
                                                </td>
                                                <td
                                                  style={{
                                                    color: `${config.txtColor}`,
                                                    border: "1px solid black",
                                                    textAlign: "center",
                                                    padding: "0 0 0 10px",
                                                    fontSize: "1.2rem",
                                                    width: "70px",
                                                  }}
                                                >
                                                  {item?.grade}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                      </tbody>
                                    </table>
                                  ) : null}
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={2} style={{ verticalAlign: "top" }}>
                              <table
                                id="DataList2"
                                className="NormalText"
                                cellSpacing="0"
                                style={{ borderCollapse: "collapse" }}
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      colSpan={3}
                                      style={{ verticalAlign: "top" }}
                                    >
                                      <p
                                        style={{
                                          fontSize: "1.25rem",
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                          marginTop: "-10px",
                                          marginLeft: "10px",
                                        }}
                                      >
                                        <b>Note.1</b> In Urdu, English, Math and
                                        Science, those students who will fail in
                                        any two subjects will be considered
                                        fail.
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "1.25rem",
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                          marginTop: "-20px",
                                          marginLeft: "10px",
                                          lineHeight: "1.5",
                                        }}
                                      >
                                        <b>Note.2</b> Those students who will
                                        fail in one subject mentioned above and
                                        will fail in other two subjects
                                        i.e.(Islamiat, S. Studies, Arabic,
                                        Drawing/H. Eco.) will be considered
                                        fail.
                                      </p>
                                      <p
                                        style={{
                                          fontSize: "1.25rem",
                                          color: `${config.txtColor}`,
                                          textAlign: "start",
                                          marginTop: "-20px",
                                          marginLeft: "10px",
                                        }}
                                      >
                                        <b>Note.3</b> In 8th Class fail in any
                                        two subjects should be considered fail.
                                      </p>
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <p
                                            style={{
                                              fontSize: "1.25rem",
                                              color: `${config.txtColor}`,
                                              textAlign: "start",
                                              marginTop: "20px",
                                              marginLeft: "10px",
                                              lineHeight: "1.5",
                                            }}
                                          >
                                            {studentRemarkCheck &&
                                            examRemark?.name ? (
                                              <>
                                                <span>
                                                  <b>Teacher's Remark: </b>
                                                </span>
                                                <br />
                                                <span>
                                                  {examRemark?.name ?? "---"}
                                                </span>
                                              </>
                                            ) : null}
                                          </p>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginRight: "20px",
                                          }}
                                        >
                                          {controllerSignatureCheck &&
                                          signatureIcon ? (
                                            <img
                                              src={signatureIcon}
                                              width={100}
                                              height={100}
                                              alt="Signature"
                                            />
                                          ) : null}
                                          <p
                                            style={{
                                              fontSize: "1.25rem",
                                              color: `${config.txtColor}`,
                                              marginTop: "10px",
                                              textAlign: "right",
                                              textDecoration: "overline",
                                            }}
                                          >
                                            <b>Controller of Examinations</b>
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="3">
                      <br />
                      <div style={{ border: "1px solid black" }}>
                        <table
                          border="0"
                          cellPadding="5"
                          cellSpacing="0"
                          width="100%"
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                <span
                                  style={{ fontSize: "1.4rem" }}
                                  id="lblAddress1"
                                  className="BoldText"
                                >
                                  {campusDetail?.campus?.name}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default ResulftCardForPrint;
